import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';

type SearchInputProps = {
    value: string | undefined;
    onChange: (value: string) => void;
}

export const SearchInput = ({ value, onChange }: SearchInputProps) => {
    const { t } = useTranslation(['misc']);

    return (
        <div className={'relative'}>
            <div className={'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'}>
                <Icon name={'search'} />
            </div>

            <input
                type="text"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={t('search')}
                className={
                    'block w-full mb-2 p-4 pl-10 rounded-full border border-surface-3 focus:border-primary bg-surface-2 hover:bg-surface-3 focus:bg-surface-3 text-on-surface focus:ring-primary focus-visible:ring-primary outline-hidden focus:outline-hidden'
                }
            />
        </div>
    );
};
